export default __webpack_public_path__ + "static/media/hxro.b4e30553.jpg";